let savingTablePeriods;
switch (COUNTRY) {
  case 'ES':
    savingTablePeriods = [6, 12, 18, 24, 36];
    break;
  default:
    savingTablePeriods = [6, 12, 18, 24, 36];
}

export default [...savingTablePeriods];
